import _ from 'lodash';
import { InputFieldConfig } from 'src/@vymo/ui/molecules/form/types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { Keys, locale } from 'src/i18n';
import { UPLOAD_FORM } from 'src/modules/constants';
import { getState } from 'src/store';
import axios from 'src/workspace/axios';
import { removeDialog, renderModule } from 'src/workspace/slice';
import { parseJSON } from 'src/workspace/utils';
import { REVYRE_FORM_CREATE_TYPE } from '../constants';
import { BULK_REVOKE, BULK_UPLOAD } from '../ddp/constants';
import { getRevyreState } from '../selectors';
import { clearNotification, setIsDialogOpen } from '../slice';
import {
  BASE_URL,
  fetchEntityList,
  fetchModuleConfig,
  getRequestHeaders,
  syncWorkflowConfigToSlice,
} from '../thunk';
import { WorkflowType } from '../types';

const onUpdate = async ({ dispatch, props }) => {
  const { domainType, workflowType, activityType, actionType } = props;
  if (actionType !== BULK_UPLOAD && actionType !== BULK_REVOKE) {
    await dispatch(fetchModuleConfig({ domainType, workflowType }));
  }

  if (activityType) {
    dispatch(fetchEntityList({ domainType, payload: {} }));
  }
  dispatch(setIsDialogOpen(true));
};

const onDeactivate = ({ dispatch, props }) => {
  dispatch(setIsDialogOpen(false));
  if (props?.type !== REVYRE_FORM_CREATE_TYPE) {
    dispatch(clearNotification());
  }
};

const onActivate = ({ dispatch }) => {
  const modulesConfig = getRevyreState(getState()).modules;
  if (_.isEmpty(modulesConfig)) {
    syncWorkflowConfigToSlice(dispatch);
  }
};

export const uploadFormSubmit = createAsyncThunk(
  'revyre/uploadFormSubmit',
  async (
    {
      inputFields,
      actionType,
      additionalData,
    }: {
      inputFields: InputFieldConfig[];
      actionType: 'bulkUpload' | 'bulkRevoke';
      additionalData: { workflowType?: WorkflowType };
    },
    { dispatch },
  ) => {
    try {
      switch (actionType) {
        case BULK_REVOKE:
        case BULK_UPLOAD: {
          const isBulkRevoke = actionType === BULK_REVOKE;
          const actionEndpoint = isBulkRevoke
            ? 'bulk-revocation'
            : 'bulk-allocation';

          const { workflowType } = additionalData || {};

          const sourceDocumentId = parseJSON(
            inputFields?.find((field) => field.type === 'multimedia')?.value,
          )?.items?.[0]?.id;

          const formFieldValues = (inputFields || [])
            .filter((field) => field.type !== 'multimedia')
            .reduce(
              (acc, field) => ({
                ...acc,
                [field.code]: field.value,
              }),
              {},
            );

          const payload = {
            entityType: workflowType,
            sourceDocumentId,
            ...formFieldValues,
          };

          const response = await axios.post(
            `${BASE_URL}/${actionEndpoint}`,
            payload,
            {
              headers: getRequestHeaders(),
            },
          );

          const { jobId } = response?.data?.payload || {};

          dispatch(
            renderModule({
              id: 'DDP_DETAILS',
              props: { jobId, actionType },
            }),
          );

          dispatch(removeDialog({ id: UPLOAD_FORM }));
          break;
        }
        default:
          return false;
      }

      return true;
    } catch (error) {
      return Promise.reject(locale(Keys.SOMETHING_WENT_WRONG));
    }
  },
);

export default { onUpdate, onDeactivate, onActivate };
